module.exports = __webpack_public_path__ + "mo/img/create01.8ced4c01.png";